type Task = {
  id: string;
  name: string;
  description: string;
  type: TaskType;
  state: TaskState;
  disabled: boolean;
  documentationURL: string;
  usefullinks: TaskLinks[];
  selected?: boolean;
  tags: string;
};

type Lego = Task & {
  image: string;
  builderId?: string;
  builderName?: string;
  path: string;
};

type Archetype = Task & {
  legos: Lego[];
};

type TopTask = {
  id: string;
  count: number;
  name: string;
  category: string;
  selected: boolean;
};

type TaskResponse = {
  tasks: Lego[];
  total: number;
};

type ArchetypeParams = {
  limit: number;
  offset: number;
  searchValue: string;
};

type ArchetypeResponse = {
  tasks: Archetype[];
  total: number;
};

type ArchetypeLego = {
  id: string;
  archetypeId: string;
  legosId: string[];
};

type DisassociateLego = {
  archetypeId: string;
  legoId: string;
};

type TaskOption = {
  icon: string;
  name: string;
  type: string;
};

type TaskParams = {
  limit: number;
  offset: number;
  state: TaskState;
  searchValue: string;
};

type TaskLinks = {
  url: string;
  name: string;
};

type LegosArchetypeParams = {
  archetypeId: string;
  limit: number;
  offset: number;
  searchValue: string;
  allLegos?: boolean;
};

enum TaskState {
  All = '',
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

enum TaskType {
  Workflow = 'WORKFLOW',
  Archetype = 'ARCHETYPE',
  Lego = 'LEGO'
}

class TaskFactory {
  public static create(lego: Lego): Lego {
    return {
      id: lego.id,
      name: lego.name,
      description: lego.description,
      image: lego.image,
      type: TaskType.Lego,
      state: lego.state,
      tags: lego.tags,
      disabled: lego.disabled,
      usefullinks: lego.usefullinks,
      documentationURL: lego.documentationURL,
      path: lego.path
    };
  }
}

interface TaskItem {
  label: string;
  value: any;
  editable: boolean;
  key: string;
  hidden: boolean;
}

const urlMapper: { [key: string]: TaskType } = {
  '/legos': TaskType.Lego,
  '/archetypes': TaskType.Archetype
};

type FieldControlType =
  | 'input'
  | 'textarea'
  | 'select'
  | 'array'
  | 'link'
  | 'link-name'
  | 'date';

export {
  Task,
  Lego,
  Archetype,
  TaskResponse,
  ArchetypeResponse,
  TaskLinks,
  TaskOption,
  TaskParams,
  ArchetypeParams,
  TaskState,
  TaskType,
  TaskFactory,
  TaskItem,
  urlMapper,
  TopTask,
  LegosArchetypeParams,
  ArchetypeLego,
  DisassociateLego,
  FieldControlType
};
